import { CompareTableSpec } from '@adapters/bigcommerce/types/compareTable';
import {
  FranchiseCompareConfig,
  FranchiseComparisonData,
} from '_components/Product/FranchiseCompareTable/types';
import { getFranchiseAttributeType } from './getFranchiseCompareAttribute';

const specOrder = ({ displayOrder }: CompareTableSpec): number => {
  const order =
    typeof displayOrder === 'string' && !displayOrder.trim()
      ? NaN
      : Number(displayOrder);

  return Number.isFinite(order) ? order : Infinity;
};

const bySpecOrder = (a: CompareTableSpec, b: CompareTableSpec): number => {
  const orderA = specOrder(a);
  const orderB = specOrder(b);

  return orderA === orderB ? 0 : orderA - orderB;
};

export function buildFranchiseCompareConfig(
  data: FranchiseComparisonData,
  locale: string
): FranchiseCompareConfig {
  const key = locale === 'fr' ? 'fr' : 'en';
  const ctaLabel = data.cta?.label?.[key]?.trim();
  const ctaUrl = data.cta?.url?.[key]?.trim();

  return {
    heading: {
      line1: data.title?.[key] || '',
    },
    ...(ctaLabel && ctaUrl
      ? { contextLink: { label: ctaLabel, url: ctaUrl } }
      : {}),
    // Franchise tables are authored in a deliberate series order, so the
    // items keep the order merch gave them.
    items: data.items ?? [],
    attributes: [...(data.comparisonSpecs ?? [])]
      .sort(bySpecOrder)
      .filter((spec) => {
        const types = [spec.code, spec.label?.en, spec.label?.fr].map(
          (specKey) => getFranchiseAttributeType(specKey ?? '')
        );
        return !types.includes('name') && !types.includes('price');
      })
      .map((spec) => ({ key: spec.code, label: spec.label })),
  };
}
